import { Routes, Route } from "react-router-dom";

import TopbarLayout from "../../Layouts/TopbarLayout";
import useRoutes from "./routes";

export default function LocationServiceM8() {
  const routes = useRoutes();
  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      if (route.items && route.items.length) {
        return getRoutes(route.items);
      }

      if (route.route) {
        return (
          <Route
            exact
            path={route.route}
            element={route.component}
            key={route.key}
          />
        );
      }

      return null;
    });

  return (
    <TopbarLayout routes={routes}>
      <Routes>{getRoutes(routes)}</Routes>
    </TopbarLayout>
  );
}
